// ── Welle B2: gemeinsamer Datums-Formatierer der App ──────────────────────────
// 'YYYY-MM-DD' (auch mit Uhrzeit dahinter) → 'TT.MM.JJJJ'. Alles andere (z. B. ein von der
// KI schon deutsch geschriebenes Datum) bleibt, wie es ist; leer → ''.
export function datumTTMMJJJJ(wert: string | null | undefined): string {
  if (!wert) return '';
  const m = String(wert).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : String(wert);
}

// Welle K1: 'YYYY-MM-DD' → 'TT.MM.' (kurz, z. B. in Chips); sonst unverändert
export function datumTTMM(wert: string | null | undefined): string {
  if (!wert) return '';
  const m = String(wert).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? `${m[3]}.${m[2]}.` : String(wert);
}
